/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import {Dimensions, Platform, StyleSheet} from 'react-native';

export default StyleSheet.create({
container: {
flex: 1,
backgroundColor: 'transparent',
marginBottom: Platform.OS === 'web'? 0: 90,
},
slide: {
flex: 1,
alignItems: 'center',
justifyContent: 'center',
backgroundColor: 'rgba(255,255,255,0)',
},
title: {
fontWeight: 'bold',
fontSize: 40,
color: 'white',
marginBottom: 30
},
text: {
fontSize: 20,
color: 'white',
margin: 20,
},
buttonCircle: {
width: 40,
height: 40,
backgroundColor: 'rgba(0, 0, 0, .2)',
borderRadius: 20,
justifyContent: 'center',
alignItems: 'center',
},
textIcon: {
flexDirection: 'column',
alignItems: 'center',
},
iconText: {
padding: 5,
color: 'white',
},
})
